<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view class="main" ></router-view>
  </div>
</template>

<script>
export default {
	name:'app',
	data() {
		return{
		}
	},
  async mounted(){
    await this.$store.dispatch('getMenus')
    //this.$store.dispatch('getUserInfoActions')
    this.dtrouter()
  },
 created(){

	},
	methods:{
  }
}
</script>

<style lang="scss">
 @import 'assets/style/index.scss';
    #app{
               width: 100%;
               height: 100%;
               margin: 0;
               padding: 0;
			 

    }
    .main{
      width: 100%;
      height: 100%;
	  //禁止横向滚动
overflow-x: hidden;

    }
</style>
